import { render, staticRenderFns } from "./AndroidBlock.vue?vue&type=template&id=0f5949cd&"
import script from "./AndroidBlock.vue?vue&type=script&lang=ts&"
export * from "./AndroidBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports